import {createReducer, on} from "@ngrx/store";
import * as researchActions from './research-queue.actions';
import {ResearchQueue} from "../../models/ResearchQueue";
export const ResearchQueueFeatureKey = 'researchQueue';
export const ResearchQueueInitialState: ResearchQueue[] = null;
export const ResearchQueueReducer = createReducer<ResearchQueue[] | null>(
  ResearchQueueInitialState,
  on(researchActions.update, (_state, { researchQueue }) => researchQueue),
);
